//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import cfr from './cfrList'
    export default{
        name:'bb_form_c',
        components: {
            cfr
        },
        data(){
            return{
                // showNerveReflexPicker:false,
                // options2:['正常','迟钝'],
                // showTensionOfLimbsPicker:false,
                // options1:['良好','受限'],
                list_id:'',
                showCfrList:false,
                showsignature:false,
                cfrText:'',
                form:{
                    room:'',
                    card:'',
                    cat_date:'',
                    name:'',
                    baby_id:'',
                    sex:'',
                    momName:'',
                    skin:[],
                    eye:'',
                    oral:'',
                    umbilical:'',
                    vomiting:'无',
                    limbTension:'1',
                    nerveReflex:'1',
                    percutaneousBilirubin:'',
                    guiding_pinions:'',
                    autograph:'',
                    shifts:'',
                    check_id:''
                },
                option:{
                    penColor:"rgb(0, 0, 0)"
                },
                baby_list:[],
                get_host:host.host
            }
        },
        created(){
            this.get_baby_list()
            if(this.$route.query.list_id){
                this.apiGetCfrList()
                this.list_id = this.$route.query.list_id
            }else{
                this.list_id = ''
                this.apiMemberInfo()
                this.form.guiding_pinions = '母乳喂养、母婴同室'
            }
        },
        methods:{
            //获取四肢张力input值
            onChangeTensionOfLimbs(val){
                this.form.limbTension=val
                this.$refs.limbTension.focus()
                this.showTensionOfLimbsPicker=false
            },
            //获取神经反射input值
            onChangeNerveReflex(val){
                this.form.nerveReflex=val
                this.$refs.nerveReflex.focus()
                this.showNerveReflexPicker=false
            },
            checkerChange(value){
                for(let item of this.baby_list){
                    if(item.id == value){
                        if(item.live_time == '0'){
                            this.$vux.toast.show({
                                type: 'cancel',
                                text: item.name+'暂未入住',
                            })
                            return
                        }
                        this.form.card = item.hand_card
                        this.form.sex = item.sex == "1" ? "男" : "女"
                        this.form.name = item.name
                    }
                }
            },
            //获取查房人列表
            apiGetCfrList(){
                let params = {
                    token: this.$cookie.get('token'),
                    store_id:this.$cookie.get('store_id'),
                }
                Api.checkRoomApi.getCheckInfo(params).then ( res => {
                    console.info("获取查房人列表",res)
                    if(res.errcode == 1){
                        this.nurser_name = res.data.nurser_name//过滤了离院，
                        this.apiDetail()
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        }) 
                    }
                })
            },
            //点击选择查房人
            selectPeople(){
                this.showCfrList = true
            },
            //赋值查房人ID
            cfrListEven(val,item){
                this.showCfrList = val
                console.info(item)
                if(item){
                    this.form.check_id = item.id
                    this.cfrText = item.user_name
                }
            },
            get_baby_list (){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.monthLiveApi.babyList(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.baby_list = res.data
                        // this.form.baby_id = res.data[0].id
                        // this.form.sex = res.data[0].sex == "1" ? "男" : "女"
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //请求用户基本信息
            apiMemberInfo(){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.checkRoomApi.memberInfo(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.form.momName = res.data.name
                        this.form.room = res.data.room_name
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            save(){
                let signature ='signature1'
                console.info(this.$refs[signature])
                let png = this.$refs[signature].save()
                this.form.autograph = encodeURI(png)
                this.showsignature = true
            },
            edit(){
                this.showsignature = false
                this.form.autograph = ''
            },
            clear(){
                let signature ='signature1'
                let refs = this.$refs[signature].clear()
                this.form.autograph = ''
            },
            //请求详情数据
            apiDetail(){
                let params = {
                    token: this.$cookie.get('token'),
                    id:this.$route.query.list_id
                }
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.bbFormApi.getBabyNursTwoFind(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        let data = res.data
                        this.form.room = data.room_number
                        this.form.card = data.id_card
                        this.form.cat_date = data.cat_date
                        this.form.name = data.baby_name
                        this.form.baby_id=data.baby_id
                        this.form.sex = data.baby_gender
                        this.form.momName = data.mom_name
                        this.form.skin = data.skin
                        this.form.eye = data.eye
                        this.form.oral = data.oral
                        this.form.umbilical = data.umbilical
                        // this.form.skinA = data.skin_jaundice
                        // this.form.skinB = data.skin_erosion
                        // this.form.skinC = data.skin_herpes_zoster
                        // this.form.skinD = data.skin_eczema
                        // this.form.skinE = data.skin_diaper_rash
                        // this.form.eyeSituation = data.eye_normal
                        // this.form.eyeSecretions = data.eye_secretion
                        // this.form.oralSmooth = data.mouth_smooth
                        // this.form.oralBurst = data.mouth_ulceration
                        // this.form.oralThrush = data.mouth_thrush
                        // this.form.umbilicalDry = data.umb_cord_outblood
                        // this.form.umbilicalBleeding = data.umb_cord_falloff
                        // this.form.umbilicalFall = data.umb_cord_secretion
                        this.form.vomiting = data.vomit
                        this.form.limbTension = data.tension_of_limbs
                        // this.form.tension_of_limbs_case = data.tension_of_limbs_case
                        this.form.nerveReflex = data.nerve_reflex
                        // this.form.nerve_reflex_case = data.nerve_reflex_case
                        this.form.percutaneousBilirubin = data.transcutaneous_bilirubin
                        this.form.guiding_pinions = data.guiding_pinions
                        this.form.autograph = data.autograph.indexOf(this.get_host) != -1 ? data.autograph : this.get_host+data.autograph
                        this.form.shifts = data.shifts
                        this.form.check_id = data.check_id
                        this.showsignature = true
                        if(this.nurser_name.length){
                            for(let item of this.nurser_name){
                                if(item.id == data.check_id){
                                    this.cfrText = item.user_name
                                }
                            }
                        }
                        this.$vux.loading.hide()
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //请求添加数据
            apiAddForm(){
                let babyName = ''
                for(let item of this.baby_list){
                    if(item.id == this.form.baby_id){
                        babyName = item.name
                    }
                }
                let params = {
                    token: this.$cookie.get('token'),
                    number_id:this.$cookie.get('id'),
                    maternal_info_id: this.$route.query.id,
                    store_id:this.$cookie.get('store_id'),
                    room_number:this.form.room,
                    id_card:this.form.card,
                    cat_date:this.form.cat_date,
                    baby_name:babyName,
                    baby_id:this.form.baby_id,
                    baby_gender:this.form.sex,
                    mom_name:this.form.momName,
                    skin: this.form.skin,
                    eye:this.form.eye,
                    oral:this.form.oral,
                    umbilical:this.form.umbilical,
                    // skin_jaundice:this.form.skinA,
                    // skin_erosion:this.form.skinB,
                    // skin_herpes_zoster:this.form.skinC,
                    // skin_eczema:this.form.skinD,
                    // skin_diaper_rash:this.form.skinE,
                    // eye_normal:this.form.eyeSituation,
                    // eye_secretion:this.form.eyeSecretions,
                    // mouth_smooth:this.form.oralSmooth,
                    // mouth_ulceration:this.form.oralBurst,
                    // mouth_thrush:this.form.oralThrush,
                    // umb_cord_outblood:this.form.umbilicalDry,
                    // umb_cord_falloff:this.form.umbilicalBleeding,
                    // umb_cord_secretion:this.form.umbilicalFall,
                    vomit:this.form.vomiting,
                    tension_of_limbs:this.form.limbTension,
                    // tension_of_limbs_case:this.form.tension_of_limbs_case,
                    nerve_reflex:this.form.nerveReflex,
                    // nerve_reflex_case:this.form.nerve_reflex_case,
                    transcutaneous_bilirubin:this.form.percutaneousBilirubin,
                    guiding_pinions:this.form.guiding_pinions,
                    autograph:this.form.autograph.indexOf(this.get_host) != -1 ? this.form.autograph.replace(this.get_host,'') : this.form.autograph,
                    shifts: this.form.shifts,
                    check_id:  this.form.check_id          
                }
                console.info(params)
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.bbFormApi.addBabyNursTwoData(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'bb_form_c',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            // 请求更新数据
            apiUpdateForm(){
                let params = {
                    token: this.$cookie.get('token'),
                    id:this.$route.query.list_id,
                    number_id:this.$cookie.get('id'),
                    maternal_info_id: this.$route.query.id,
                    store_id:this.$cookie.get('store_id'),
                    room_number:this.form.room,
                    id_card:this.form.card,
                    cat_date:this.form.cat_date,
                    baby_name:this.form.name,
                    baby_id:this.form.baby_id,
                    baby_gender:this.form.sex,
                    mom_name:this.form.momName,
                    skin: this.form.skin,
                    eye:this.form.eye,
                    oral:this.form.oral,
                    umbilical:this.form.umbilical,
                    // skin_jaundice:this.form.skinA,
                    // skin_erosion:this.form.skinB,
                    // skin_herpes_zoster:this.form.skinC,
                    // skin_eczema:this.form.skinD,
                    // skin_diaper_rash:this.form.skinE,
                    // eye_normal:this.form.eyeSituation,
                    // eye_secretion:this.form.eyeSecretions,
                    // mouth_smooth:this.form.oralSmooth,
                    // mouth_ulceration:this.form.oralBurst,
                    // mouth_thrush:this.form.oralThrush,
                    // umb_cord_outblood:this.form.umbilicalDry,
                    // umb_cord_falloff:this.form.umbilicalBleeding,
                    // umb_cord_secretion:this.form.umbilicalFall,
                    vomit:this.form.vomiting,
                    tension_of_limbs:this.form.limbTension,
                    // tension_of_limbs_case:this.form.tension_of_limbs_case,
                    nerve_reflex:this.form.nerveReflex,
                    // nerve_reflex_case:this.form.nerve_reflex_case,
                    transcutaneous_bilirubin:this.form.percutaneousBilirubin,
                    guiding_pinions:this.form.guiding_pinions,
                    autograph:this.form.autograph,
                    shifts:this.form.shifts,
                    check_id:  this.form.check_id            
                }
                console.info(params)
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.bbFormApi.updateBabyNursTwoData(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'bb_form_c',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            submitForm(){
                let form = this.form
                console.info(form)
                if(form.card == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入手卡号',
                    })
                    return
                }
                if(form.cat_date == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择日期',
                    })
                    return
                }
                if(form.baby_id == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择宝宝',
                    })
                    return
                }
                if(form.skin.length == 0){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择皮肤',
                    })
                    return
                }
                if(form.eye == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择眼',
                    })
                    return
                }
                if(form.oral == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择口腔',
                    })
                    return
                }
                if(form.umbilical == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择脐带',
                    })
                    return
                }
                if(form.vomiting == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入呕吐',
                    })
                    return
                }
                if(form.limbTension == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择四肢张力',
                    })
                    return
                }
                if(form.nerveReflex == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择神经反射',
                    })
                    return
                }
                if(form.percutaneousBilirubin == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入经皮胆红素',
                    })
                    return
                }
                if(form.guiding_pinions == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入指导意见',
                    })
                    return
                }
                if(form.autograph == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入签名',
                    })
                    return
                }
                if(form.shifts == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择班次',
                    })
                    return
                }
                if(form.check_id == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择查房人',
                    })
                    return
                }
                // 判断宝宝是否入住
                let time = 0
                if(this.baby_list.length){
                    for(let item of this.baby_list){
                        if(item.id == this.form.baby_id){
                            time = item.live_time
                        }
                    }
                }
                if(time == '0'){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '该宝宝暂未入住',
                    })
                    return
                }
                // if(form.room == '' || form.card == '' || form.baby_id == ''  || form.cat_date == '' || form.sex == '' || form.shifts == '' || form.check_id == '' || form.momName == '' || form.date == '' || form.birtherDay == '' || form.weight == '' || form.bobyWeight == '' || form.voice == '' || form.temperature == '' || form.urinate == '' || form.bowelsNum == '' || form.bowelsNature == '' || form.fontanelle == '' || form.skin == '' || form.instruction == '' || form.signature == ''){
                //     this.$vux.toast.show({
                //         type: 'cancel',
                //         text: '请完善所有表单',
                //     })
                //     return
                // }
                if(this.$route.query.list_id){
                    console.info("请求更新数据")
                    this.apiUpdateForm()
                }else{
                    console.info("请求添加数据")
                    this.apiAddForm()
                }
            }
        }
    }



// WEBPACK FOOTER //
// ./src/components/bb_form_c.vue